var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.7 21h12.6M12 12.692c1.546 0 2.8-1.24 2.8-2.769 0-1.53-1.254-2.77-2.8-2.77-1.546 0-2.8 1.24-2.8 2.77s1.254 2.77 2.8 2.77Zm7-2.769C19 16.153 12 21 12 21S5 16.154 5 9.923c0-1.836.737-3.597 2.05-4.895A7.04 7.04 0 0 1 12 3a7.04 7.04 0 0 1 4.95 2.028A6.885 6.885 0 0 1 19 9.923Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.bcfd73336c638b993fdfd254c3321a07.svg";
export { ForwardRef as ReactComponent };